import React, { useState } from "react"
import SVG from "react-inlinesvg";
import { useSelector, shallowEqual, useDispatch } from "react-redux"
import SimpleTable from "my-simple-react-table";
import { toAbsoluteUrl } from "../../../../../../../../../../_metronic/_helpers";
import { formatAmount, formatStatus, formatDate, permissionCssClass } from "../../../../../../../../../util/Helpers"
import ViewPaymentModal from "./modal/ViewPaymentModal";
import WithdrawModal from "./modal/WithdrawModal";
import { Permissions, PermissionType } from "../../../../../../../../../util/Permissions";
import EditPaymentModal from "../../../../../../../../PaymentManagement/pages/modals/EditPaymentModal";
import { Button } from "react-bootstrap";
import AddPaymentModal from "./modal/AddPaymentModal";
import { FilterGroup } from "../../../../../../../../Common/components/FilterGroup"
import { useDownloadPaymentsReportMutation, useGetPaymentsSummaryQuery } from "../../../../../../../../../../redux/apiSlice";
import cogoToast from "cogo-toast";
import { useEffect } from "react";
import * as selectedUserHandlers from "../../../../../../../_redux/selected-user/selectedUserHandlers";

const Payments = props => {

    const adminUser = useSelector(state => state.auth.user);
    /* Get Account Payments from redux */
    const { payments, currency, partner, userGroup } = useSelector(({ selectedUser }) => {
        const selectedUserAccounts = selectedUser.data?.accounts.filter(acc => acc.accountId === props.match.params.accountId)[0]?.details;
        return { ...selectedUserAccounts, userGroup: selectedUser.data?.profile?.userGroup };
    }, shallowEqual);

    const dispatch = useDispatch();
    const { userId, accountId } = props.match.params;
    const { data: paymentsSummaryResponse, isFetching: isFetchingPaymentsSummary } = useGetPaymentsSummaryQuery(
        { userId, accountId },
        { skip: !userId || !accountId }
    );
    const paymentSummaries = Array.isArray(paymentsSummaryResponse?.data)
        ? paymentsSummaryResponse.data
        : Array.isArray(paymentsSummaryResponse)
            ? paymentsSummaryResponse
            : [];
    const depositSummaries = paymentSummaries.filter(entry => entry?.type?.toUpperCase() === "DEPOSIT");
    const withdrawalSummaries = paymentSummaries.filter(entry => {
        const paymentType = entry?.type?.toUpperCase();
        return paymentType === "WITHDRAW" || paymentType === "WITHDRAWAL";
    });

    // Fetch payments when component mounts or userId/accountId changes
    useEffect(() => {
        dispatch(selectedUserHandlers.fetchUserAccountDetails(userId, accountId));
    }, [dispatch, userId, accountId]);

    const refreshPayments = () => {
        dispatch(selectedUserHandlers.fetchUserAccountDetails(userId, accountId));
    };

    /* Payment Modal State Management */
    const [paymentModal, setPaymentModal] = useState({ showViewPaymentModal: false, showEditPaymentModal: false, showWithdrawModal: false, showAddPaymentModal: false, details: null });

    const formatActivity = row => {
        return <div className="d-flex align-items-center" style={{ whiteSpace: "nowrap" }}>

            <span className={`svg-icon svg-icon-lg svg-icon-${row.type === "DEPOSIT" ? "primary" : "danger"} mr-3`}>
                <SVG
                    title=""
                    src={toAbsoluteUrl("/media/svg/icons/Shopping/Gift.svg")}
                />
            </span>
            <div>
                <span className=" mb-1 font-size-lg">
                    {row.type}
                    <span className="text- pl-2">
                        / {row.method ? ` ${row.method}` : "***"}
                    </span>
                    <span className="text- pl-2">
                        / {row.last4 ? ` ****${row.last4}` : "***"}
                    </span>
                </span>
            </div>
        </div>
    }


    /* Modal show/hide Toggle */
    const toggleModal = modal => _ => {
        setPaymentModal({ ...paymentModal, [modal]: !paymentModal[modal] })
    }

    const viewPayment = details => {
        setPaymentModal({...paymentModal, showViewPaymentModal: true, details});
    }

    /* Edit Order Modal*/
    const editPayment = details => {
        setPaymentModal({
            ...paymentModal,
            showEditPaymentModal: true,
            details
        })
    }

    const paymentButton = row => {

        return  <span style={{whiteSpace: "nowrap"}}>  
                    <button
                        className="btn btn-icon btn-white btn-hover-primary btn-sm mx-0"
                        onClick={_ => viewPayment(row)}
                        >
                        <span className="svg-icon svg-icon-md svg-icon-primary">
                            <SVG
                            title="View payment"
                            src={toAbsoluteUrl("/media/svg/icons/General/Eye-2.svg")}
                            />
                        </span>
                    </button>

            <Button
                title="Edit Payment"
                className={`btn btn-icon btn-light btn-hover-primary btn-sm mx-3 ${permissionCssClass(adminUser, Permissions.PAYMENTS, PermissionType.UPDATE)}`}
                onClick={_ => editPayment(row)}

            >
                <span className="svg-icon svg-icon-md svg-icon-primary">
                    <SVG
                        title="Edit Payment"
                        src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")}
                    />
                </span>
            </Button>
        </span>
    }

    const [
        downloadPaymentsReport,
        {
            isLoading: isLoadingReport,
            isSuccess: isReportGenerating,
            error: errorReport,
        }
    ] = useDownloadPaymentsReportMutation();

    useEffect(() => {
        if (errorReport) {
            cogoToast.error(errorReport.data);
        }
    }, [errorReport])

    useEffect(() => {
        if (isReportGenerating) {
            cogoToast.success(`Payments export in progress. The resulting file will be sent to your mail.`);
        }
    }, [isReportGenerating])

    const renderSummaryRows = (entries, emptyLabel) => {
        if (isFetchingPaymentsSummary) {
            return <span className="text-muted font-weight-bold font-size-sm">Loading...</span>;
        }
        if (entries.length === 0) {
            return <span className="text-muted font-weight-bold font-size-sm">{emptyLabel}</span>;
        }
        return entries.map(entry => (
            <div key={`${entry.type}-${entry.currency}`} className="d-flex justify-content-between align-items-center mb-2">
                <span className="text-dark-75 font-weight-bolder">{entry.currency || "-"}</span>
                <span className="text-dark font-weight-bolder">{formatAmount(entry.currency, entry.totalCharged)}</span>
            </div>
        ));
    };

    return (
        <FilterGroup
            defaultFilters={{
                endDate: new Date().toISOString().split('T')[0],
            }}
        >
            <div className="row">
                <div className="col-12">
                    {/* <!--begin::List Widget 14--> */}
                    <div className="card card-custom gutter-b">
                        {/* <!--begin::Header--> */}
                        <div className="card-header border-0">
                            {/* <!--begin::Title--> */}
                            <div className="card-title pt-5 w-100">
                                <h3 className="card-label">
                                    <span className="d-block text-dark h3 font-weight-bolder">Payments</span>
                                    <span className="d-block text-muted mt-2 font-size-sm">Cash Deposit and Withdrawal</span>
                                </h3>
                                <div className={`card-toolbar ml-auto ${permissionCssClass(adminUser, Permissions.PAYMENTS, PermissionType.CREATE)}`}>
                                    <button
                                        className="btn btn-primary font-weight-bolder font-size-sm"
                                        onClick={toggleModal("showAddPaymentModal")}
                                    >
                                        <span className="svg-icon svg-icon-md svg-icon-white">
                                            <SVG
                                                title=" "
                                                src={toAbsoluteUrl("/media/svg/icons/Shopping/Gift.svg")}
                                            />
                                        </span>
                                        Add Payment
                                    </button>
                                    <button
                                        className="btn btn-primary font-weight-bolder font-size-sm ml-5"
                                        onClick={toggleModal("showWithdrawModal")}
                                    >
                                        <span className="svg-icon svg-icon-md svg-icon-white">
                                            <SVG
                                                title=" "
                                                src={toAbsoluteUrl("/media/svg/icons/Shopping/Wallet3.svg")}
                                            />
                                        </span>
                                        Withdraw
                                    </button>
                                    <div className="d-flex flex-column ml-5">
                                        <FilterGroup.Content>
                                            {({ filters }) => (
                                                <button
                                                    type="button"
                                                    className="btn btn-primary"
                                                    disabled={isLoadingReport}
                                                    onClick={() => downloadPaymentsReport({
                                                        userId: props.match.params.userId,
                                                        startDate: filters?.startDate || "",
                                                        endDate: filters?.endDate || "",
                                                        type: filters?.type || "",
                                                        format: "csv",
                                                        userGroup: userGroup || "", // Pass userGroup
                                                    })}
                                                >
                                                    Export CSV
                                                </button>
                                            )}
                                        </FilterGroup.Content>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="px-6 pb-4">
                            <div className="row mb-2">
                                <div className="col-md-6 mb-4">
                                    <div className="card card-custom gutter-b bg-light-success border-0 shadow-none h-100 mb-0">
                                        <div className="card-body py-5">
                                            <div className="font-size-sm text-muted font-weight-bold text-uppercase mb-2">Payment Summary</div>
                                            <div className="font-size-h5 font-weight-bolder text-dark mb-4">Total Deposits</div>
                                            {renderSummaryRows(depositSummaries, "No deposit summary available")}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 mb-4">
                                    <div className="card card-custom gutter-b bg-light-danger border-0 shadow-none h-100 mb-0">
                                        <div className="card-body py-5">
                                            <div className="font-size-sm text-muted font-weight-bold text-uppercase mb-2">Payment Summary</div>
                                            <div className="font-size-h5 font-weight-bolder text-dark mb-4">Total Withdrawals</div>
                                            {renderSummaryRows(withdrawalSummaries, "No withdrawal summary available")}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 mb-4">
                                <FilterGroup.DateRange />
                            </div>
                            <div className="col-12 mb-4">
                                <FilterGroup.Filter name={"type"} label={"payment type"}>
                                    <FilterGroup.Option value={""}>All</FilterGroup.Option>
                                    <FilterGroup.Option value={"DEPOSIT"}>Deposits</FilterGroup.Option>
                                    <FilterGroup.Option value={"WITHDRAW"}>Withdrawals</FilterGroup.Option>
                                    <FilterGroup.Option value={"PORTFOLIO_CREATION"}>Portfolio Creations</FilterGroup.Option>
                                    <FilterGroup.Option value={"CARD_CREATION"}>Virtual Card Creations</FilterGroup.Option>
                                    <FilterGroup.Option value={"CARD_DEPOSIT"}>Virtual Card Deposits</FilterGroup.Option>
                                </FilterGroup.Filter>
                            </div>
                        </div>

                        {/* <!--end::Header--> */}
                        {/* <!--begin::Body--> */}
                        <div className="card-body pt-0">
                            <FilterGroup.Content>
                                {({ filters }) => {
                                     const filteredPayments = payments.filter(payment => {
                                        const paymentDate = new Date(payment.createdAt);
                                        const startDate = filters?.startDate ? new Date(filters.startDate) : null;
                                        const endDate = filters?.endDate ? new Date(filters.endDate).setHours(23, 59, 59, 999) : null;
                                        const paymentType = filters?.type;

                                        return (
                                            (!startDate || paymentDate >= startDate) &&
                                            (!endDate || paymentDate <= endDate) &&
                                            (!paymentType || payment.type === paymentType)
                                        );
                                    });

                                    return (
                                        <SimpleTable
                                            data={filteredPayments}
                                            columns={[
                                                { title: "ACTIVITY", format: formatActivity },
                                                { title: "REFERENCE", key: "ref" },
                                                { title: "CURRENCY", key: "currency" },
                                                { title: "AMOUNT", format: row => formatAmount(row.currency, row.amount) },
                                                { title: "STATUS", format: row => formatStatus(row.status) },
                                                { title: "DATE", format: row => formatDate(row.createdAt) },
                                                { title: "", format: paymentButton }
                                            ]}
                                        />
                                    );
                                }}
                            </FilterGroup.Content>
                        </div>
                    </div>
                    {/* <!--end::List Widget 14--> */}
                </div>

                {paymentModal.showViewPaymentModal && <ViewPaymentModal {...paymentModal} onHide={toggleModal("showViewPaymentModal")} />}
                {paymentModal.showWithdrawModal && <WithdrawModal {...paymentModal} {...props} currency={currency} onHide={toggleModal("showWithdrawModal")} refreshPayments={refreshPayments} />}
                {paymentModal.showAddPaymentModal && <AddPaymentModal {...paymentModal} {...props} currency={currency} partner={partner} onHide={toggleModal("showAddPaymentModal")} refreshPayments={refreshPayments} />}

                {
                    paymentModal.showEditPaymentModal &&
                    <EditPaymentModal
                        {...paymentModal}
                        onHide={toggleModal("showEditPaymentModal")}
                        refreshPayments={refreshPayments}
                    />
                }
            </div>
        </FilterGroup>
    );
}

export default Payments;
